import TioLoadingSpinner from '../../tio/loading-spinner.gts';

const LoadingRow = <template>
  <div class="grid grid-cols-10 gap-8 p-4 border-b tio-border-default items-center">
    <div class="tio-flex-center col-span-10 py-2">
      <TioLoadingSpinner />
    </div>
  </div>
</template>;

export default LoadingRow;
